// src/router/index.js 或 src/router/index.ts
import Vue from 'vue'
import Router from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router';
import login from '../views/login.vue';
import layout from '../views/Layout/layout.vue';
import main from '../views/Main/main.vue';
import reservation from '../views/reservation.vue';
import teacher from '../views/teacher.vue';
import course from '../views/course.vue';
import statistics from '../views/statistics.vue';
import { $reLogin } from '@/api/login';


//  Vue.use(Router);

const routes = [
  {
    path: '',
    name: '登录',
    component: ()=>import('../views/login.vue'),
  },
  {
    path: '/layout',
    name: 'layout',
    component: layout,
    children:[
      {
        path:"/main",
        name:"首页",
        component:main
      },
      {
        path:"/reservation",
        name:"预约管理",
        component:reservation
      },
      {
        path:"/course",
        name:"课程管理",
        component:course
      },
      {
        path:"/teacher",
        name:"师资管理",
        component:teacher
      }
      ,
      {
        path:"/statistics",
        name:"统计管理",
        component:statistics
      }
    ]
  },
  {
    path: '/login',
    name: '登录',
    component: ()=>import('../views/login.vue'),
 
  }
  , {
    path:"/:pathMatch(.*)*",
    name:"登陆",
    component: ()=>import('../views/login.vue'),
  }
];
 



const router = createRouter({
    routes, // `routes: routes` 的缩写
  history: createWebHistory(), // 使用HTML5 History模式

//   history:createWebHashHistory(),

});

//验证是否登陆
router.beforeEach(async(to,from,next)=>{
  
  if(to.path==='/layout'){
      let userInfo=localStorage.getItem("userInfo");
      if(!userInfo){
        router.push("/login")
      }
  }else if(to.path==='/login' ||to.path==='/'){
      //从本地缓存试着取一下值
      let  username= localStorage.getItem("username");
      let  password= localStorage.getItem("password");
      let  remember= localStorage.getItem("remember");
      if(remember==true || remember=='true'){
        if(username && password){
            let code= await $reLogin();
            if(code === '200'){
              router.push("/layout")
            }
        }
      }
  }
  next();
})
router.afterEach((to,from)=>{
  document.title=to.name
})



 
export default router;